require('../../../modules/es.array.slice');

var entryVirtual = require('../../../internals/entry-virtual');

module.exports = entryVirtual('Array').slice;